import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Layout } from 'antd'
import PropTypes from 'prop-types'

import NavigationBar from './navigation-bar'
import { Page as PageContainer, PageContent } from './styled'

const Page = ({ children }) => {
  const location = useLocation()
  useEffect(() => {
    if (!location.state?.preserveScroll) window.scrollTo(0, 0)
  }, [location])

  return (
    <Layout>
      <PageContainer>
        <NavigationBar />
        <PageContent>
          <Layout.Content>{children}</Layout.Content>
        </PageContent>
      </PageContainer>
    </Layout>
  )
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Page
